import { WorkspaceRoutine } from "../../routine";

export interface Group {
  id: string;
  name: string;
  routines?: WorkspaceRoutine[];
}
